module.exports = __webpack_public_path__ + "static/media/blinds.88cdde91.svg";